import { AnyAction } from 'redux';
import { Dispatch } from 'react';

import { linter } from '@codemirror/lint';

import { calculateLineStartIndexes } from '@redux/note-details/calculate-line-start-indexes';
import { customDiagnosticType, errorExtractor } from '../utils/error-extractor';
import { setFormatIssues } from '@redux/format-checker/formatChecker';

export const markdownLinter = (
  dispatch: Dispatch<AnyAction>,
  imageDataTrigger: Function,
  hasImageToolsAccess: boolean = false,
) => {

  // Remove duplicate errors having same line number and error message
  // added to handle edge case for section close
  const errorDuplicationRemove = (formatIssues: customDiagnosticType[]) => {
    const errorSet = new Set();
    const uniqueErrors = formatIssues.filter((issue) => {
      if (!issue.lineNo || !issue.message ) return false;
      const duplicate = errorSet.has(issue.lineNo + issue.message);
      errorSet.add(issue.lineNo + issue.message);
      return !duplicate;
    });
    return uniqueErrors;
  };

  return linter((view) => {
    const markdown = view.state.doc.toString();
    const lines = markdown.split('\n');
    // array of line with sum of previous line length
    const lineStartIndexes = calculateLineStartIndexes(lines);
    const { issuesArr, toolsArr, warningArr } = errorExtractor(
      lines,
      lineStartIndexes,
      dispatch,
      imageDataTrigger,
      hasImageToolsAccess
    );
    const uniqueErrors = errorDuplicationRemove(issuesArr);
    dispatch(setFormatIssues(uniqueErrors));
    const combineLinter = [...uniqueErrors, ...toolsArr, ...warningArr];
    return combineLinter;
  });
};
